import React from "react";
import { ArrowDown, ArrowUp, Search } from "lucide-react";

import { number, signed, toneClass } from "./marketFormat";
import baseStyles from "./marketObservation.module.css";
import linkStyles from "./industryMemberTable.module.css";
import tableStyles from "./marketTables.module.css";

const styles = { ...baseStyles, ...tableStyles };

const COLUMNS = [
  ["name", "股票"],
  ["l2_industry", "二级行业"],
  ["price", "现价"],
  ["pct_chg", "今日"],
  ["pct_chg_5d", "5日"],
  ["total_mv_yi", "总市值"],
  ["turnover_rate", "换手率"],
  ["main_net_inflow_yi", "主力净额"],
];

export function IndustryMemberTable({
  filteredCount,
  memberOrder,
  memberQuery,
  memberSort,
  navigate,
  page,
  pageCount,
  pageSize,
  returnTo,
  setMemberOrder,
  setMemberQuery,
  setMemberSort,
  setPage,
  visibleMembers,
}) {
  function toggleSort(key) {
    if (memberSort === key) {
      setMemberOrder(memberOrder === "desc" ? "asc" : "desc");
      return;
    }
    setMemberSort(key);
    setMemberOrder("desc");
  }

  return (
    <section className={styles.tableCard}>
      <div className={styles.tableToolbar}>
        <div>
          <strong>成分股</strong>
          <span className={styles.resultCount}>共 {filteredCount.toLocaleString("zh-CN")} 只 · 每页 {pageSize} 只</span>
        </div>
        <label className={styles.searchBox}>
          <Search size={16} />
          <input value={memberQuery} onChange={(event) => setMemberQuery(event.target.value)} placeholder="搜索股票、代码或二级行业" />
        </label>
      </div>
      <div className={styles.tableScroll}>
        <table className={styles.memberTable}>
          <thead>
            <tr>
              {COLUMNS.map(([key, label]) => (
                <th key={key} aria-sort={memberSort === key ? (memberOrder === "asc" ? "ascending" : "descending") : "none"}>
                  <button onClick={() => toggleSort(key)}>
                    {label}
                    {memberSort === key && (memberOrder === "desc" ? <ArrowDown size={13} /> : <ArrowUp size={13} />)}
                  </button>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibleMembers.map((item) => (
              <tr key={item.code} className={item.status !== "ok" ? styles.missingRow : ""}>
                <td>
                  <button
                    type="button"
                    className={linkStyles.memberStockLink}
                    onClick={() => navigate(`/stock/${item.code}?from=${encodeURIComponent(returnTo)}`)}
                  >
                    <strong>{item.name ?? "名称缺失"}</strong><small>{item.code}</small>
                  </button>
                </td>
                <td>{item.l2_industry_code ? (
                  <button className={styles.subindustryLink} onClick={() => navigate(`/industry/${item.l2_industry_code}`)}>{item.l2_industry}</button>
                ) : item.l2_industry ?? "--"}</td>
                <td>{number(item.price)}</td>
                <td className={toneClass(item.pct_chg, styles)}>{signed(item.pct_chg)}</td>
                <td className={toneClass(item.pct_chg_5d, styles)}>{signed(item.pct_chg_5d)}</td>
                <td>{item.total_mv_yi ? `${number(item.total_mv_yi, 1)} 亿` : "--"}</td>
                <td>{item.turnover_rate ? `${number(item.turnover_rate)}%` : "--"}</td>
                <td className={toneClass(item.main_net_inflow_yi, styles)}>{item.main_net_inflow_yi ? signed(item.main_net_inflow_yi, " 亿", 2) : "--"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={styles.pagination}>
        <button disabled={page <= 1} onClick={() => setPage((value) => Math.max(1, value - 1))}>上一页</button>
        <span>第 {page} / {pageCount} 页</span>
        <button disabled={page >= pageCount} onClick={() => setPage((value) => Math.min(pageCount, value + 1))}>下一页</button>
      </div>
    </section>
  );
}
